"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[24038],{

/***/ 10567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 20px;\n  }\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3a0d262d-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 18401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82127);






var ModalBlockedReqOTP = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _title = param.title, title = _title === void 0 ? "" : _title, _submitText = param.submitText, submitText = _submitText === void 0 ? "Back to Settings" : _submitText, _onBack = param.onBack, onBack = _onBack === void 0 ? function() {} : _onBack;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .ModalConfirmation */ .o7, {
        visible: visible,
        centered: true,
        width: "400px",
        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {}),
        onCancel: onBack,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                direction: "column",
                py: "30px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: "/icon/password-otp-locked.svg",
                        alt: "lock",
                        style: {
                            marginBottom: "18px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "700",
                        size: "16px",
                        height: "26px",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        weight: "400",
                        size: "14px",
                        height: "22px",
                        children: "You’ve reached the limit of verification code requests."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                type: "primary",
                width: "160px",
                height: "40px",
                radius: "4px",
                onClick: onBack,
                // @ts-expect-error
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: submitText
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalBlockedReqOTP);


/***/ }),

/***/ 66029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CountDown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var initialSecond = param.initialSecond, onCountEnd = param.onCountEnd, onCountStart = param.onCountStart;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialSecond), timeLeft = _$ref[0], setTimeLeft = _$ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        onCountStart();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (timeLeft <= 0) {
            onCountEnd();
            return;
        }
        var intervalId = setInterval(function() {
            setTimeLeft(function(prevTime) {
                return prevTime - 1;
            });
        }, 1000);
        // eslint-disable-next-line consistent-return
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        timeLeft
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            getTimeLeft: function() {
                return timeLeft;
            }
        };
    });
    var formatTime = function(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return "".concat(String(minutes).padStart(2, "0"), ":").concat(String(remainingSeconds).padStart(2, "0"));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: formatTime(timeLeft)
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (CountDown);


/***/ }),

/***/ 24038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ change_forgot_password_SectionOTPField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
;// CONCATENATED MODULE: ./src/assets/customIcon/IconRadioSelect.tsx


function IconRadioSelect(param) {
    var _selected = param.selected, selected = _selected === void 0 ? false : _selected, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return selected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "10",
                cy: "10",
                r: "7.5",
                fill: "#00AB6B"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7 10L8.55751 11.6873C8.71593 11.8589 8.98445 11.8668 9.15269 11.7048L13 8",
                stroke: "white",
                strokeWidth: "1.25",
                strokeLinecap: "round"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
            cx: "10",
            cy: "10",
            r: "6.875",
            stroke: "#CBCBCB",
            fill: disabled ? "#F7F7F7" : "none",
            strokeWidth: "1.25"
        })
    });
};

// EXTERNAL MODULE: ./src/global/Icons/CloseSvg.tsx
var CloseSvg = __webpack_require__(79928);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/features/change-forgot-password/styled.ts
var styled = __webpack_require__(82127);
// EXTERNAL MODULE: ./src/features/change-forgot-password/SectionOTPCountdown.tsx
var SectionOTPCountdown = __webpack_require__(66029);
// EXTERNAL MODULE: ./src/features/change-forgot-password/config.ts
var config = __webpack_require__(636);
// EXTERNAL MODULE: ./src/features/change-forgot-password/utils.ts
var utils = __webpack_require__(28292);
;// CONCATENATED MODULE: ./src/features/change-forgot-password/ModalOTPOptions.tsx















var ModalOTPOptions = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, closeModal = param.closeModal, _initalSecond = param.initalSecond, initalSecond = _initalSecond === void 0 ? 10 : _initalSecond, _selectedOption = param.selectedOption, selectedOption = _selectedOption === void 0 ? "" : _selectedOption, otpOptions = param.otpOptions, setSelectedOption = param.setSelectedOption, resetCountDown = param.resetCountDown, onRequestOTP = param.onRequestOTP;
    var countdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), optionAvailable = ref[0], setOptionAvailable = ref[1];
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    (0,react.useEffect)(function() {
        setOptionAvailable(initalSecond === 0);
    }, [
        initalSecond
    ]);
    var options = [
        {
            value: config/* CHANNEL_OTP.EMAIL */.U.EMAIL,
            icon: "/icon/password-email-small.svg",
            text: "Send via Email",
            subText: (0,utils/* maskEmail */.o)(data === null || data === void 0 ? void 0 : data.email)
        },
        {
            value: config/* CHANNEL_OTP.WHATSAPP */.U.WHATSAPP,
            icon: "/icon/password-whatsapp.svg",
            text: "Send via Whatsapp",
            subText: (0,utils/* maskPhoneNumber */.Y)(data === null || data === void 0 ? void 0 : data.phone)
        },
        {
            value: config/* CHANNEL_OTP.SMS */.U.SMS,
            icon: "/icon/password-message.svg",
            text: "Send via SMS",
            subText: (0,utils/* maskPhoneNumber */.Y)(data === null || data === void 0 ? void 0 : data.phone)
        }, 
    ];
    var optionsToRender = otpOptions !== null && otpOptions !== void 0 ? otpOptions : options;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalOptionOTP */.kK, {
        title: "Choose Verification Code Method",
        visible: visible,
        centered: true,
        width: "480px",
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseSvg/* default */.Z, {
            width: "10px",
            height: "10px",
            strokeWidth: "2"
        }),
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: optionAvailable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    pb: "12px",
                    children: "Verification code will be sent via the chosen method:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !optionAvailable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    pb: "12px",
                    children: [
                        "Send new verification code in",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionOTPCountdown/* default */.Z, {
                                ref: countdownRef,
                                initialSecond: initalSecond,
                                onCountEnd: function() {
                                    return setOptionAvailable(true);
                                },
                                onCountStart: function() {
                                    return setOptionAvailable(false);
                                }
                            })
                        })
                    ]
                })
            }),
            optionsToRender.map(function(o) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* OptionOTP */.Lb, {
                    active: o.value === selectedOption && optionAvailable,
                    onClick: function() {
                        return optionAvailable ? setSelectedOption(o.value) : undefined;
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: o.icon,
                            alt: "icon"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* OptionOTPText */._K, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    weight: o.value === selectedOption && optionAvailable ? "bold" : "normal",
                                    children: o.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "#858585",
                                    children: o.subText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconRadioSelect, {
                            selected: o.value === selectedOption && optionAvailable,
                            disabled: !optionAvailable
                        })
                    ]
                }, o.value);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                align: "end",
                direction: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "primary",
                    radius: "4px",
                    height: "40px",
                    // @ts-expect-error
                    mt: "25px",
                    width: "186px",
                    disabled: !optionAvailable,
                    onClick: function() {
                        closeModal();
                        resetCountDown();
                        onRequestOTP();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Send Verification Code"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var change_forgot_password_ModalOTPOptions = (ModalOTPOptions);

// EXTERNAL MODULE: ./src/features/change-forgot-password/ModalBlockedReqOTP.tsx
var ModalBlockedReqOTP = __webpack_require__(18401);
;// CONCATENATED MODULE: ./src/features/change-forgot-password/SectionOTPField.tsx
/* eslint-disable react/destructuring-assignment */ 

















var KEY_CODE_BACKSPACE = 8;
var KEY_CODE_DELETE = 46;
var KEY_CODE_ENTER = 13;
var SectionTitle = function(param) {
    var title = param.title, subTitle = param.subTitle, img = param.img;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: img,
                width: "70px",
                height: "70px",
                alt: "password-email",
                style: {
                    marginBottom: "18px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    paddingBottom: "18px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        weight: 700,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#858585",
                        // @ts-expect-error
                        pt: "10px",
                        dangerouslySetInnerHTML: {
                            __html: subTitle
                        }
                    })
                ]
            })
        ]
    });
};
var SectionOTPField = function(param) {
    var onSubmit = param.onSubmit, onRequestOTP = param.onRequestOTP, _requestOTPOnload = param.requestOTPOnload, requestOTPOnload = _requestOTPOnload === void 0 ? true : _requestOTPOnload, _multipleOTPMethodAvailable = param.multipleOTPMethodAvailable, multipleOTPMethodAvailable = _multipleOTPMethodAvailable === void 0 ? true : _multipleOTPMethodAvailable, preventSubmit = param.preventSubmit, submitText = param.submitText, setOtpConfig = param.setOtpConfig, otpConfig = param.otpConfig, otpLength = param.otpLength, otpData = param.otpData, error = param.error, resetError = param.resetError, blockedOtpCtaText = param.blockedOtpCtaText, blockedOtpCtaCallback = param.blockedOtpCtaCallback, otpOptions = param.otpOptions;
    var ref;
    var router = (0,next_router.useRouter)();
    var countdownRef = (0,react.useRef)(null);
    var inputRef = (0,react.useRef)((0,_to_consumable_array/* default */.Z)(Array(otpLength)).map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    }));
    var ref1 = (0,react.useState)((0,_to_consumable_array/* default */.Z)(Array(otpLength))), inputValue = ref1[0], setInputValue = ref1[1];
    var ref2 = (0,react.useState)(false), showModalOptions = ref2[0], setShowModalOptions = ref2[1];
    var ref3 = (0,react.useState)(false), showModalBlocked = ref3[0], setShowModalBlocked = ref3[1];
    var ref4 = (0,react.useState)(false), countDownEnd = ref4[0], setCountDownEnd = ref4[1];
    var onResetInput = function() {
        setInputValue((0,_to_consumable_array/* default */.Z)(inputValue).map(function() {
            return "";
        }));
        inputRef.current[0].current.focus();
    };
    var requestOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return onRequestOTP();
                    case 3:
                        onResetInput();
                        _ctx.next = 10;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        if ((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.errorType) === "OTP_LIMIT_EXCEEDED") {
                            setShowModalBlocked(true);
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function requestOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInput = function(e) {
        return function(index) {
            var ref;
            var value = ((ref = e.target) === null || ref === void 0 ? void 0 : ref.value) || "";
            if (e.keyCode !== KEY_CODE_BACKSPACE && e.keyCode !== KEY_CODE_DELETE) {
                var sanitizedInput = /\D/.test(value) ? "" : value[0];
                setInputValue((0,_to_consumable_array/* default */.Z)(inputValue).map(function(v, i) {
                    return i === index ? sanitizedInput : v;
                }));
                if (index < otpLength - 1 && Boolean(sanitizedInput)) {
                    inputRef.current[index + 1].current.focus();
                }
            }
            if (e.keyCode === KEY_CODE_BACKSPACE) {
                setInputValue((0,_to_consumable_array/* default */.Z)(inputValue).map(function(v, i) {
                    return i === index ? "" : v;
                }));
                if (index > 0 && index <= otpLength - 1) {
                    inputRef.current[index - 1].current.focus();
                }
            }
            if (e.keyCode === KEY_CODE_ENTER && !preventSubmit) {
                onSubmit();
            }
        };
    };
    var renderTitle = function(option) {
        var _obj;
        var titleContent = (_obj = {}, (0,_define_property/* default */.Z)(_obj, config/* CHANNEL_OTP.EMAIL */.U.EMAIL, /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
            title: "Enter Your Email Verification Code",
            subTitle: "Verification code has been sent to your email\n            <b>".concat(otpData.target, "</b>\n          "),
            img: "/icon/password-email.svg"
        })), (0,_define_property/* default */.Z)(_obj, config/* CHANNEL_OTP.WHATSAPP */.U.WHATSAPP, /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
            title: "Enter Your Whatsapp Verification Code",
            subTitle: "Verification code has been sent to <b>".concat(otpData.target, "</b>"),
            img: "/icon/password-wa.svg"
        })), (0,_define_property/* default */.Z)(_obj, config/* CHANNEL_OTP.SMS */.U.SMS, /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle, {
            title: "Enter Your SMS Verification Code",
            subTitle: "Verification code has been sent to <b>".concat(otpData.target, "</b>"),
            img: "/icon/password-sms.svg"
        })), _obj);
        return titleContent[option] || null;
    };
    (0,react.useEffect)(function() {
        resetError();
        setOtpConfig({
            channel: otpConfig.channel,
            otp: inputValue.join("")
        });
    }, [
        inputValue
    ]);
    (0,react.useEffect)(function() {
        if (requestOTPOnload) requestOtp();
    }, [
        requestOTPOnload
    ]);
    (0,react.useEffect)(function() {
        resetError();
    }, []);
    (0,react.useEffect)(function() {
        if (inputRef.current) {
            var handlePaste = function(e) {
                if (e === null || e === void 0 ? void 0 : e.clipboardData) {
                    e.preventDefault();
                    var pastedData = e === null || e === void 0 ? void 0 : e.clipboardData.getData("Text");
                    setInputValue((0,_to_consumable_array/* default */.Z)(pastedData.split("")).map(function(v, i) {
                        if (i >= otpLength) {
                            return "";
                        }
                        var sanitizedInput = /\D/.test(v) ? "" : v;
                        return sanitizedInput;
                    }));
                }
            };
            inputRef.current.forEach(function(c) {
                c.current.addEventListener("paste", handlePaste);
            });
            return function() {
                inputRef.current.forEach(function(c) {
                    var ref;
                    (ref = c.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("paste", handlePaste);
                });
            };
        }
        return function() {};
    }, [
        inputRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(change_forgot_password_ModalOTPOptions, {
                visible: showModalOptions,
                closeModal: function() {
                    return setShowModalOptions(false);
                },
                onRequestOTP: requestOtp,
                initalSecond: countDownEnd ? 0 : (countdownRef === null || countdownRef === void 0 ? void 0 : (ref = countdownRef.current) === null || ref === void 0 ? void 0 : ref.getTimeLeft()) || otpData.remainingSecond,
                selectedOption: otpConfig.channel,
                setSelectedOption: function(channel) {
                    setOtpConfig({
                        channel: channel,
                        otp: channel !== otpConfig.channel ? "" : otpConfig.otp
                    });
                },
                resetCountDown: function() {
                    return setCountDownEnd(false);
                },
                otpOptions: otpOptions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBlockedReqOTP/* default */.Z, {
                visible: showModalBlocked,
                title: error,
                onBack: function() {
                    return blockedOtpCtaCallback !== undefined ? blockedOtpCtaCallback() : router.push("/profile/edit");
                },
                submitText: blockedOtpCtaText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                height: "455px",
                direction: "column",
                children: [
                    renderTitle(otpConfig.channel),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            width: "100%",
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                align: "center",
                                style: {
                                    gap: 16
                                },
                                mb: "10px",
                                children: (0,_to_consumable_array/* default */.Z)(Array(otpLength)).map(function(_e, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputOTPContainer */.Io, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputOTP */.Zn, {
                                            autoFocus: i === 0,
                                            ref: inputRef.current[i],
                                            value: inputValue[i],
                                            onChange: function(e) {
                                                return onChangeInput(e)(i);
                                            },
                                            onKeyDown: function(e) {
                                                return onChangeInput(e)(i);
                                            },
                                            id: "input-email-otp-verify-".concat(i + 1),
                                            "data-cy": "confirm-otp-input-box",
                                            style: {
                                                fontWeight: "bold"
                                            },
                                            autoComplete: "off"
                                        })
                                    }, "input-token".concat(i + 1));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: Boolean(error),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    // @ts-expect-error
                                    pb: "8px",
                                    style: {
                                        visibility: error ? "visible" : "hidden"
                                    },
                                    "data-cy": "new-password-error-validation",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                            size: "16px",
                                            className: "icon-toolbar_error",
                                            color: color/* default.sunsetOrange */.Z.sunsetOrange
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                            size: "12px",
                                            weight: "400px",
                                            // @ts-expect-error
                                            pl: "5px",
                                            children: error
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !countDownEnd && otpData.remainingSecond > 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: "#858585",
                                    pb: "16px",
                                    pt: "5px",
                                    children: [
                                        "Resend (",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionOTPCountdown/* default */.Z, {
                                            ref: countdownRef,
                                            initialSecond: otpData.remainingSecond,
                                            onCountEnd: function() {
                                                setCountDownEnd(true);
                                            },
                                            onCountStart: function() {
                                                return setCountDownEnd(false);
                                            }
                                        }),
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: countDownEnd || otpData.remainingSecond === 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                                    type: "borderless",
                                    // @ts-expect-error
                                    pl: "0px",
                                    pb: "16px",
                                    pt: "5px",
                                    onClick: function() {
                                        setCountDownEnd(false);
                                        onResetInput();
                                        requestOtp();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#00ab6b",
                                        weight: "700",
                                        children: "Resend"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: multipleOTPMethodAvailable,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: color/* default.primary */.Z.primary,
                                    weight: "700",
                                    style: {
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setShowModalOptions(true);
                                    },
                                    children: "Try Another Way"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                        block: true,
                        type: "primary",
                        height: "44px",
                        radius: "4px",
                        onClick: onSubmit,
                        disabled: preventSubmit,
                        // @ts-expect-error
                        mt: "auto",
                        mb: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: submitText
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var change_forgot_password_SectionOTPField = (SectionOTPField);


/***/ }),

/***/ 636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CHANNEL_OTP; },
/* harmony export */   "c": function() { return /* binding */ OTP_LENGTH; }
/* harmony export */ });
var OTP_LENGTH = 6;
var CHANNEL_OTP;
(function(CHANNEL_OTP) {
    CHANNEL_OTP["EMAIL"] = "CHANNEL_EMAIL";
    CHANNEL_OTP["SMS"] = "CHANNEL_SMS";
    CHANNEL_OTP["WHATSAPP"] = "CHANNEL_WHATSAPP";
})(CHANNEL_OTP || (CHANNEL_OTP = {}));


/***/ }),

/***/ 82127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HF": function() { return /* binding */ GuestLayout; },
/* harmony export */   "Io": function() { return /* binding */ InputOTPContainer; },
/* harmony export */   "Lb": function() { return /* binding */ OptionOTP; },
/* harmony export */   "Zn": function() { return /* binding */ InputOTP; },
/* harmony export */   "_K": function() { return /* binding */ OptionOTPText; },
/* harmony export */   "kK": function() { return /* binding */ ModalOptionOTP; },
/* harmony export */   "o7": function() { return /* binding */ ModalConfirmation; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var global_GuestLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67251);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-color: ",
        ";\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          border-color: ",
        ";\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 70px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  margin: 8px 0;\n  align-items: center;\n  padding: 20px;\n\n  :hover {\n    background-color: #f7f7f7;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 10px;\n  width: 90%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-title {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 22px;\n  }\n  .ant-modal-header {\n    padding: 20px 20px 16px 20px;\n    border-radius: 8px 8px 0 0;\n  }\n  .ant-modal-body {\n    padding: 0 20px 20px;\n  }\n  .ant-modal-content {\n    border-radius: 8px;\n  }\n\n  .ant-btn-primary[disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0 30px 25px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 24px;\n  overflow: hidden;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  border-bottom: 1px solid rgb(218, 218, 218);\n  width: 24px;\n  height: 36px;\n  font-size: 16px;\n  text-align: center;\n  padding: 0;\n  outline: none;\n\n  :focus,\n  :focus-within,\n  :not([value='']) {\n    border-color: #00ab6b;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  padding: 0;\n\n  @media ",
        " {\n    padding: 0;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :disabled {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}







var OptionOTP = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b5de838d-0"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, function(props) {
    return props.active ? (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary) : (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray);
});
var OptionOTPText = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5de838d-1"
})(_templateObject3());
var ModalOptionOTP = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b5de838d-2"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].hummingBird */ .Z.hummingBird);
var ModalConfirmation = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(ModalOptionOTP).withConfig({
    componentId: "sc-b5de838d-3"
})(_templateObject5());
var InputOTPContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b5de838d-4"
})(_templateObject6());
var InputOTP = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-b5de838d-5"
})(_templateObject7());
var GuestLayout = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(global_GuestLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b5de838d-6"
})(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].laptop */ .Z.laptop, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].whiteSmoke */ .Z.whiteSmoke);
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b5de838d-7"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].hummingBird */ .Z.hummingBird);



/***/ }),

/***/ 28292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ maskPhoneNumber; },
/* harmony export */   "o": function() { return /* binding */ maskEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);


function maskEmail() {
    var email = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(email.split("@"), 2), username = ref[0], domain = ref[1];
    var maskedUsername = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(username.split("")).map(function(v, i) {
        return i < 2 ? v : "*";
    }).join("");
    return "".concat(maskedUsername, "@").concat(domain);
}
function maskPhoneNumber() {
    var phoneNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var maskedPhone = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(phoneNumber.split("")).map(function(v, i) {
        return i < 4 || i > phoneNumber.length - 4 ? v : "*";
    }).join("");
    return maskedPhone;
}


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 67251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_GuestLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/statics/Box.js
var Box = __webpack_require__(10567);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/GuestLayout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n    margin: 8px 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  min-height: 100vh;\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n\n        @media ",
        " {\n          border-bottom: 1px solid ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 72px;\n        padding: 22px 20px;\n\n        img {\n          height: 40px;\n          width: 75px;\n        }\n        button {\n          width: 99px;\n          height: 28px;\n        }\n        button.button-login p,\n        button.button-register p {\n          font-size: 12px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 20px 10px;\n\n      img {\n        height: 40px;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0;\n\n        @media ",
        " {\n          padding: 20px 30px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-0"
})(_templateObject(), color/* default.highempahis */.Z.highempahis);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-1"
})(_templateObject1(), color/* default.whiteSmoke */.Z.whiteSmoke, device/* default.tablet */.Z.tablet);
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-2"
})(_templateObject4(), function(param) {
    var isGuestCompanyStock = param.isGuestCompanyStock;
    if (isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var HeaderFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5ecd13a1-3"
})(_templateObject7(), function(props) {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), device/* default.laptop */.Z.laptop);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var MainContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5ecd13a1-4"
})(_templateObject10(), function(props) {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});


;// CONCATENATED MODULE: ./src/global/GuestLayout/index.tsx











var GuestLayout = function(param) {
    var children = param.children, _noBox = param.noBox, noBox = _noBox === void 0 ? false : _noBox, _noAuth = param.noAuth, noAuth = _noAuth === void 0 ? false : _noAuth, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock, _className = param.className, className = _className === void 0 ? "" : _className;
    var router = (0,next_router.useRouter)();
    var date = new Date();
    var year = date.getFullYear();
    var isGuestCompanyStock = isCompanyStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                isGuestCompanyStock: isGuestCompanyStock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderFlex, {
                    align: "center",
                    direction: "row",
                    justify: "space-between",
                    // @ts-expect-error
                    mx: "auto",
                    isGuestCompanyStock: isGuestCompanyStock,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/stockbit.svg",
                                    alt: "Stockbit"
                                })
                            })
                        }),
                        !noAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "row",
                            justify: "center",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            // @ts-expect-error
                                            mr: "16px",
                                            className: "button-login",
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            type: isGuestCompanyStock ? "default" : "borderless",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: isGuestCompanyStock ? color/* default.highempahis */.Z.highempahis : color/* default.pinkSwan */.Z.pinkSwan,
                                                children: "Login"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "primary",
                                            className: "button-register",
                                            // @ts-expect-error
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                router.push("/register");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: color/* default.light */.Z.light,
                                                children: "Register"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                // @ts-expect-error
                mx: "auto",
                mb: "24px",
                isGuestCompanyStock: isGuestCompanyStock,
                children: noBox ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        width: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        "2013-",
                        year,
                        " Stockbit \xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "About"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://help.stockbit.com/id",
                            children: "Help"
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/rules",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "House Rules"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Terms"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Privacy"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
GuestLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBox: (prop_types_default()).bool,
    noAuth: (prop_types_default()).bool
};
GuestLayout.defaultProps = {
    noBox: false,
    noAuth: false
};
/* harmony default export */ var global_GuestLayout = (GuestLayout);


/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke, _width = param.width, width = _width === void 0 ? "1em" : _width, _height = param.height, height = _height === void 0 ? "1em" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: height,
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ })

}]);